import { columnName, formatValue, typeSpecificProps } from "helpers/reports";
import React from "react";
import CommonReport from "./commonReport";

export default class DailyVehicleMileageReport extends CommonReport {
    idColumn = {
        Header: "#",
        id: "row",
        filterable: false,
        sticky: true,
        width: 50,
        Cell: ({ row }) => <div>{row.index + 1}</div>,
    };

    extractColumns = () => {
        const { columns } = this.props.data || {};
        return [this.idColumn].concat(
            columns.filter((item) => !!item.label && item.propertyName !== "Number").map(this.cellProps),
        );
    };

    cellProps = (column) => {
        return {
            Header: column.label,
            accessor: (originalRow) =>
                column.index !== null ? originalRow[column.propertyName] : originalRow[columnName(column)],
            show: !column.isAdditionalColumn,
            sticky: column.propertyName === "Car",
            Cell: (props) => {
                const uniqueId = { [`data-${column.propertyName}`.toLowerCase()]: "" };
                switch (column.propertyName) {
                    case "Logists": {
                        return (
                            <div className="long-text" {...uniqueId}>
                                {formatValue(props.value.join("; "), column.clrType)}
                            </div>
                        );
                    }
                    default:
                        return (
                            <div className="long-text" {...uniqueId}>
                                {formatValue(props.value, column.clrType)}
                            </div>
                        );
                }
            },
            Footer: () => this.footerVal(column),
            ...typeSpecificProps(column),
        };
    };
}
